<template>
  <v-row>
    <v-col cols="12">
      <DataTable
        :height="$vuetify.breakpoint.md ? undefined : 'calc(100vh - 260px)'"
        :form="form"
        :table-data="tableData"
        :pagination="pagination"
        :params="params"
        :options="options"
        @on-reset="reset"
        @on-search="getData(1)"
        @on-edit="showDialogForm('edit', $event)"
        @on-create="showDialogForm('create')"
        @on-export="exportData"
        @deleted="getData()"
        @updated="getData()"
        @refreshed="getData()"
        @sorted="handleSort"
      />
    </v-col>
    <v-col cols="12">
      <Pagination
        :length="pagination.lastPage"
        :total="pagination.total"
        :params="params"
        @onPageChange="getData"
        @onPerPageChange="getData(1)"
      />
    </v-col>
  </v-row>
</template>

<script>
import DataTable from './components/DataTable.vue'
import Search from './components/Search.vue'
import Pagination from '@/components/Pagination.vue'
import { exportPlots, index } from '@/api/plot'
import indexMixin from '@/mixins/crud/index'
import { getWards } from '@/api/category'
export default {
  components: {
    DataTable,
    Search,
    Pagination,
  },

  mixins: [
    indexMixin(
      index,
      {
        wards: {
          func: getWards,
          params: { select: 'id*name', sortBy: 'id' },
        },
      },
      exportPlots,
    ),
  ],

  data() {
    return {
      model: 'plot',
      showDialog: false,
      editing: false,
      defaultParams: {
        page: 1,
        perPage: 20,
        sortBy: 'id:asc',
        gov: true,
        wards: [],
        landTypes: [],
        kide: '',
      },
      form: {},
    }
  },
}
</script>
